/**
 * 邮箱验证
 */
//const regexEmail = /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
const regexEmail = /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/;

/**
 * 用户名验证
 */
const regexUsername = /^(?![0-9]+$)[a-zA-Z0-9\u4e00-\u9fa5]{4,20}$/;

/**
 * 密码验证
 */
const regexPassword = /^(?![0-9]+$)(?![a-zA-Z]+$)(?![`\-=[\];'\\,./!@#$%^&*()_+{}:"|<>?]+$)[0-9A-Za-z`\-=[\];'\\,./!@#$%^&*()_+{}:"|<>?]{8,20}$/;

export { regexEmail, regexUsername, regexPassword };
